import observerPolyfill from 'intersection-observer';
import { scroll_to_target } from './animations';
import _ from 'lodash';

const simulateClick = function (elem) {
	// Create our event (with options)
	var evt = new MouseEvent('click', {
		bubbles: true,
		cancelable: true,
		view: window,
	});
	// If cancelled, don't dispatch our event
	var canceled = !elem.dispatchEvent(evt);
};

function activeSection(config = null, sections)
{
	const defaultConfig = {
		root: null,
		rootMargin: '0px',
		threshold: 0.1,
	};

	if(config == null)
	{
		config = defaultConfig;
	}

	if(!sections || sections.length <= 0)
	{
		return;
	}

	if ('IntersectionObserver' in window)
	{
		let sectionObserver = new IntersectionObserver(function(entries, observer)
		{
			entries.forEach(function(entry)
			{
				let activeSection = entry.target;

				if (entry.isIntersecting) {
					sectionActive(entry);
				} else {
					if(activeSection.classList.contains('data-table__cell'))
					{
						sectionInactive(entry);
					}
				}
			});
		}, config);

		sections.forEach(function(section)
		{
			sectionObserver.observe(section);
		});
	}
	else
	{
		let io = new observerPolyfill(function(entries)
		{
			entries.forEach(function(entry) {
				let activeSection = entry.target;

				if (entry.isIntersecting) {
					sectionActive(entry);
				} else {
					if(activeSection.classList.contains('data-table__cell'))
					{
						sectionInactive(entry);
					}
				}
			});
		}, config);

		sections.forEach(function(section)
		{
			io.POLL_INTERVAL = 100;
			io.observe(section);
		});
	}
}

// TODO: This doesn't seem to actually do anything. Remove??
export function initPushstate()
{
	var popped = ('state' in window.history && window.history.state !== null), initialURL = location.href;

	// listen to popstate events
	window.addEventListener('popstate', function (event) {
		// Ignore inital popstate that some browsers fire on page load
		var initialPop = !popped && location.href == initialURL
		popped = true;

		if (initialPop) {
			return;
		}
	});
}

function sectionActive(entry)
{
	const activeSection = entry.target;
	const sectionHash = activeSection.getAttribute('data-location');

	if (
		history.pushState && // check pushState is available
		sectionHash &&
		sectionHash.startsWith('#')
	) {
		// TODO: don't replace state if user actively navigated to a hash link

		const newUrl = new URL(window.location);
		newUrl.hash = sectionHash;
		const newUrlString = newUrl.toString();

		// create updated state for swup
		const newState = Object.assign({}, history.state);
		newState.url = newUrlString;

		history.replaceState(newState, null, newUrlString);
	}


	activeSection.classList.add('active');

	const wrapper = activeSection.parentNode.parentNode.parentNode.parentNode.parentNode;
	if(wrapper && wrapper !== null && wrapper.classList)
	{
		if(wrapper.classList.contains('table-block__grid'))
		{
			wrapper.classList.add('active');
		}
	}
}

function sectionInactive(entry)
{
	let activeSection = entry.target;
	let wrapper = activeSection.parentNode.parentNode.parentNode.parentNode.parentNode;

	if(wrapper && wrapper !== null)
	{
		wrapper.classList.remove('active');
	}
}

export function setupActiveSections()
{
	let sections = [].slice.call(document.querySelectorAll('[data-wp]'));
	activeSection(null, sections);
}

export const checkLandingActive = (() => {
	const instance = {
		liveFeed: undefined,
		landing: undefined,
		visited: false,
	};

	const body = document.body;

	instance.triggerScroll = (e) => {
		scroll_to_target(instance.liveFeed, { speed: 0.3 })
	}

	instance.scrollDown = _.throttle((e) => {
		if(body.classList.contains('landing-scrolled'))
		{
			return
		}

		if(body.classList.contains('landing-inactive'))
		{
			scroll_to_target(instance.liveFeed)

			body.classList.remove('landing-inactive');
		}

		if((window.scrollY >= instance.liveFeed.offsetTop - 20) && !instance.visited)
		{
			body.classList.add('landing-scrolled');
			instance.visited = true;

			setTimeout(() => {
				instance.landing.classList.add('disabled');
			}, 200 )
		}
	}, 50)

	instance.init = () => {
		const liveFeed = document.querySelector('.live-feed');
		const landing = document.querySelector('.landing');
		const trigger = document.querySelector('.landing-darr');

		if(!liveFeed || !landing || !trigger)
		{
			return;
		}

		body.classList.add('landing-inactive');

		instance.liveFeed = liveFeed;
		instance.landing = landing;

		window.addEventListener('scroll', instance.scrollDown);
		document.addEventListener('touchend', instance.scrollDown, true);

		trigger.addEventListener('click', instance.triggerScroll);
	}

	// Why did I add this? I'm not sure
	instance.reset = () => {
		body.classList.remove('landing-scrolled');
		instance.visited = false;
		instance.landing.classList.remove('disabled');
		window.removeEventListener('scroll', instance.scrollDown);
		document.removeEventListener('touchend', instance.scrollDown);
	}

	return instance;
})()



// WEBPACK FOOTER //
// ./scripts/modules/waypoints.js